import { Close, Lens } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import { useCallback, useEffect, useRef, useState } from 'react';

import { Button } from '../../Button/Button';
import { TextInput } from '../TextInput';

import styles from './SearchInput.module.scss';
import { SearchInputProps } from './SearchInput.types';

export const SearchInput = ({
  size = 'large',
  value,
  onValueChange,
  collapsed,
  showSearchButton,
  onBlur,
  ...props
}: SearchInputProps) => {
  const [localValue, setLocalValue] = useState(value?.toString() ?? '');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => setLocalValue(value?.toString() ?? ''), [value]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        onValueChange?.(localValue);
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [onValueChange, localValue]
  );

  const ref = useRef<HTMLInputElement>(null);

  return collapsed && !(value || localValue || isOpen) ? (
    <Button
      size={size === 'small' ? 'medium' : size === 'medium' ? 'large' : 'xlarge'}
      variant="tertiary"
      onClick={() => {
        setIsOpen(true);
        setTimeout(() => ref.current?.focus());
      }}
    >
      <Lens />
    </Button>
  ) : (
    <div className={styles.container}>
      <TextInput
        size={size}
        value={localValue}
        onValueChange={setLocalValue}
        leftIcon={showSearchButton && <Lens />}
        rightIcon={
          !showSearchButton &&
          (value === localValue && value !== '' ? (
            <Button
              variant="tertiary"
              onClick={() => {
                setLocalValue('');
                onValueChange?.('');
                ref.current?.focus();
              }}
            >
              <Close />
            </Button>
          ) : (
            <Button
              variant="tertiary"
              onClick={event => {
                onValueChange?.(localValue);
                event.stopPropagation();
              }}
            >
              <Lens />
            </Button>
          ))
        }
        ref={ref}
        onKeyDown={handleKeyDown}
        onBlur={event => {
          setIsOpen(false);
          onBlur?.(event);
        }}
        {...props}
      />
      {showSearchButton &&
        (value === localValue && value !== '' ? (
          <Button
            size={size === 'small' ? 'medium' : size === 'medium' ? 'large' : 'xlarge'}
            variant="tertiary"
            onClick={() => {
              setLocalValue('');
              onValueChange?.('');
              ref.current?.focus();
            }}
          >
            réinitialiser
          </Button>
        ) : (
          <Button
            size={size === 'small' ? 'medium' : size === 'medium' ? 'large' : 'xlarge'}
            variant="tertiary"
            onClick={() => onValueChange?.(localValue)}
          >
            rechercher
          </Button>
        ))}
    </div>
  );
};
